import { FileType } from '@/models/file.model';

export const getFileTypeByFormat = (fileName: string): FileType => {
  const fileType = fileName.split('.').pop() ?? '';
  return fileType as FileType;
};
